module.exports = __webpack_public_path__ + "img/stock6.be27c2ce.png";